import React from 'react';
import { Wrench, Mail, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark border-t border-brand-border pt-16 pb-8" data-id="element-108">
      <div className="container mx-auto px-4 md:px-6" data-id="element-109">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 mb-12" data-id="element-110">
          <div className="text-center md:text-left max-w-sm" data-id="element-111">
            <div className="flex items-center justify-center md:justify-start gap-2 text-white font-heading text-2xl tracking-wider mb-4" data-id="element-112">
              <Wrench className="text-brand-yellow w-6 h-6" data-id="element-113" />
              <span data-id="element-114">
                SABER-DIGITAL
                <span className="text-brand-yellow text-sm align-top" data-id="element-115">™</span>
              </span>
            </div>
            <p className="text-zinc-400 text-sm" data-id="element-116">
              El sistema de mantenimiento de monociclos eléctricos N°1 para el
              rider argentino.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-117">
            <a href="mailto:soportesaberdigital0@gmail.com" className="flex items-center gap-2 text-zinc-400 hover:text-brand-yellow transition-colors" data-id="element-118">
              <Mail className="w-5 h-5" data-id="element-119" />
              <span data-id="element-120">soportesaberdigital0@gmail.com</span>
            </a>
            <a href="#" className="flex items-center gap-2 text-zinc-400 hover:text-brand-yellow transition-colors" data-id="element-121">
              <Instagram className="w-5 h-5" data-id="element-122" />
              <span data-id="element-123">@saberdigital</span>
            </a>
          </div>
        </div>

        <div className="text-center border-t border-brand-border pt-8" data-id="element-124">
          <p className="text-zinc-500 text-sm mb-4" data-id="element-125">
            © SABER-DIGITAL™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-brand-yellow font-heading tracking-wider flex items-center justify-center gap-2" data-id="element-126">
            <Wrench className="w-4 h-4" data-id="element-127" />
            "El próximo lunes puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}